import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("¡Cuenta creada!");
      navigate("/cuenta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al crear cuenta");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-24" data-testid="register-page">
      <h1 className="font-serif text-5xl tracking-tighter">Crea tu cuenta</h1>
      <p className="mt-2 text-[#5B605E]">Recibe ofertas exclusivas y guarda tus pedidos.</p>
      <form onSubmit={submit} className="mt-10 space-y-4">
        <input data-testid="reg-name" required placeholder="Tu nombre" value={name} onChange={(e) => setName(e.target.value)} className="w-full bg-transparent border-b border-[#2C302E] py-3 focus:outline-none" />
        <input data-testid="reg-email" type="email" required placeholder="Correo" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-[#2C302E] py-3 focus:outline-none" />
        <input data-testid="reg-password" type="password" required minLength={6} placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-[#2C302E] py-3 focus:outline-none" />
        <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full mt-6">{loading ? "Creando…" : "Crear cuenta"}</button>
      </form>
      <p className="mt-6 text-sm text-[#5B605E]">¿Ya tienes cuenta? <Link to="/login" className="link-underline text-[#A94438]">Ingresa</Link></p>
    </div>
  );
}
